import Global from 'mystical/public/Global.js';

const GlobalStyles = () => {
  return <Global styles={{}} />;
};

export default GlobalStyles;
